import {createAction} from "redux-act";

export const getEntryPointData = createAction();
export const getEntryPointDataSuccess = createAction();
export const getEntryPointDataFailed = createAction();
